import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Oops! We can't seem to find that page. Try searching for an event?", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_layout = _resolveComponent("layout")!

  return (_openBlock(), _createBlock(_component_layout, { full: true }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}